module.exports = __webpack_public_path__ + "img/diegomoya.41896576.jpg";